__turbopack_context__.v({
  "Button": "index-module__PAk30a__Button",
  "Close": "index-module__PAk30a__Close",
  "Content": "index-module__PAk30a__Content",
  "Description": "index-module__PAk30a__Description",
  "Text": "index-module__PAk30a__Text",
  "Title": "index-module__PAk30a__Title",
  "Toast": "index-module__PAk30a__Toast",
  "Viewport": "index-module__PAk30a__Viewport",
});
